import { t } from 'i18next';
import React, { useReducer } from 'react'
import { useNavigate } from 'react-router-dom';
import { getAccessOpeningsService } from '../../services/accessOpenings';
import AccessOpeningContext from './AccessOpeningContext'
import AccessOpeningReducer from './AccessOpeningReducer';
import { logout } from '../../services/login';
import { setUserData } from '../../helpers/helpers';

const AccessOpeningState = ({ children }) => {

    const initialState = {
        accessOpenigs: [],
        isFetching: true,
        wasFetched: false,
        error: false,
        message: ''
    };

    const [state, dispatch] = useReducer(AccessOpeningReducer, initialState);

    const navigate = useNavigate();

    const setAccessOpening = (accessOpening) => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const newData = {
            ...userData,
            accessOpening
        }
        setUserData(newData)
    };

    const getAccessOpenings = async (isFilter = false, forceRefresh = false) => {
        try {
            if (state.wasFetched === false || forceRefresh === true) {
                dispatch({
                    type: 'IS_FETCHING'
                });
                const response = await getAccessOpeningsService();
                if (response.ok) {
                    if (isFilter === false) {
                        if (response.data.response.length === 0) {
                            setAccessOpening({ codigo: '', descripcion: t('NO_OPENING') })
                            navigate('/selectAccessBuildings');
                        }

                        if (response.data.response.length === 1) {
                            setAccessOpening(response.data.response[0])
                            navigate('/selectAccessBuildings');
                        }
                    }
                    dispatch({
                        type: 'GET_ACCESS_OPENINGS',
                        payload: response.data.response
                    })
                } else {
                    const errorType = await response.data.json();
                    switch (errorType.error_code) {
                        case 'AUTH_ERROR':
                            dispatch({
                                type: 'ERROR_SERVER',
                                payload: t('TOKEN_ERROR')
                            })
                            setTimeout(() => {
                                logout();
                            }, 1000);
                            break;
                        default:
                            dispatch({
                                type: 'ERROR_SERVER',
                                payload: t('ERROR_TRY_AGAIN')
                            })
                            break;
                    }
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    return (
        <AccessOpeningContext.Provider
            value={{
                accessOpeningState: state,
                getAccessOpenings,
                setAccessOpening
            }}
        >
            {children}
        </AccessOpeningContext.Provider>
    )
}

export default AccessOpeningState